import React from 'react';

export function ApprovedDot() {
  return <div className="my-auto h-4 w-4 rounded-full bg-mint-medical-green"></div>;
}
